/* eslint-disable
    camelcase,
    no-console
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import {Model as SequencePrimer, SequencePrimerAttributes} from 'biojs/SequencePrimer';
import {AttachPrimerOptions} from 'constants/AttachPrimerConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface FindPrimersResultsFetchResponse {
  [sequenceId: string]: {
    higher_tm_results: boolean;
    lower_tm_results: boolean;
    max_results: number;
    more_results: boolean;
    results: Array<SequencePrimerAttributes>;
  };
}

interface FindPrimersResultsFetchOptions {
  data: AttachPrimerOptions;
}

interface FindPrimersResultsOptions {
  sequence_id: string;
}

export default class FindPrimersResultsCollection extends Backbone.Collection<SequencePrimer> {
  sequence_id!: string;

  static initClass(): void {
    this.prototype.model = SequencePrimer;
  }

  // @ts-expect-error Backbone defines URL as an instance attribute, not a method
  url(): string {
    return `/1/api/sequences/${this.sequence_id}/find-primers`;
  }

  initialize(models: Array<SequencePrimer>, {sequence_id}: FindPrimersResultsOptions): void {
    this.sequence_id = sequence_id;
  }

  parse(response: FindPrimersResultsFetchResponse): Array<SequencePrimerAttributes> {
    return response[this.sequence_id].results;
  }

  // @ts-expect-error we're redefining the signature for fetch here; Backbone expects to return an XHR
  fetch(options: FindPrimersResultsFetchOptions): JQueryPromise<FindPrimersResultsFetchResponse[string]> {
    // eslint-disable-next-line no-restricted-syntax
    const keys = _.keys(options);
    if (!(keys.length === 1 && options.data != null)) {
      console.warn(`FindPrimersResults.fetch only supports data, got ${keys}.`);
    }
    const deferred = $.Deferred<FindPrimersResultsFetchResponse[string]>();
    TaskRunner.postJSON({
      url: this.url(),
      data: options.data,
    })
      .fail((res) => deferred.reject(res))
      .done((res) => {
        // @ts-expect-error This is fine; models given to Collection.set can be object-y partials
        this.set(this.parse(res), {silent: true});
        this.trigger('sync', this);
        return deferred.resolve(res[this.sequence_id]);
      });
    return deferred.promise();
  }
}

FindPrimersResultsCollection.initClass();
